/**
 * Truncates wallet address after {n} chars
 *
 * @param address
 * @param truncateAfter - default 6.
 * @returns string
 */
export const getTruncatedAddress = (address: string, truncateAfter: number = 6) =>
  `0x${address.replace("0x", "").substring(0, truncateAfter)}...${address.substring(address.length - truncateAfter)}`
